export default __webpack_public_path__ + "static/media/symphony_oddysey.792917e8.mp3";